import React from 'react';
import { IShow } from '@eagerdog/interfaces';
import styles from './ShowElementsRow.module.scss';

interface IShowElementsRowProps {
  show: IShow;
  onClick?: () => void;
}

const ShowElementsRow: React.FC<IShowElementsRowProps> = ({ show, onClick }) => {
  // Don't render if no show elements
  if (!show.show_elements || show.show_elements.length === 0) {
    return null;
  }

  // Build a deduplicated list of class names.
  // When multiple entries share the same show_element (e.g. HTD Level I / II / III),
  // show the element name once rather than repeating every level.
  const elementCounts = show.show_elements.reduce<Record<string, number>>((acc, se) => {
    const key = se.show_element ?? '';
    acc[key] = (acc[key] ?? 0) + 1;
    return acc;
  }, {});

  const seen = new Set<string>();
  const classNames = show.show_elements
    .map(se => {
      const key = se.show_element ?? '';
      // If this element appears more than once it has multiple levels/sections —
      // show just the element name and deduplicate.
      if (elementCounts[key] > 1) {
        if (seen.has(key)) return null;
        seen.add(key);
        return se.show_element;
      }
      // Single entry: prefer the level label, fall back to element name.
      return se.level || se.show_element;
    })
    .filter(Boolean)
    .join(', ');

  return (
    <div className={styles.showElementsRow} onClick={onClick}>
      <span className={styles.label}>Classes Offered:</span>
      <span className={styles.classList}>{classNames}</span>
    </div>
  );
};

export default ShowElementsRow;
